package ro.horatiu_udrea.resursedeblocat

interface Platform {
    val name: String
    val isDesktop: Boolean get() = false
}

data class User(
    val id: String,
    val name: String?,
    val email: String?,
    val photoUrl: String?,
    val isAdmin: Boolean = false
)

expect fun getPlatform(): Platform

expect fun executeGoogleLogin(
    onSuccess: (User) -> Unit,
    onFailure: (String) -> Unit
)

expect fun onAuthStateChanged(
    onUserChanged: (User?) -> Unit
)

expect fun executeLogout()

expect fun getResources(
    userId: String,
    onSuccess: (List<ResourceDetails>) -> Unit,
    onFailure: (String) -> Unit
)

expect fun addResource(
    userId: String,
    resource: ResourceDetails,
    onSuccess: (String) -> Unit,
    onFailure: (String) -> Unit
)

expect fun updateResourceState(
    userId: String,
    resourceId: String,
    newState: ResourceState,
    onSuccess: () -> Unit,
    onFailure: (String) -> Unit
)

expect fun deleteResource(
    userId: String,
    resourceId: String,
    onSuccess: () -> Unit,
    onFailure: (String) -> Unit
)

expect fun recommendResource(
    subcategory: String,
    context: String,
    resourceTypes: List<String>,
    onSuccess: (ResourceDetails) -> Unit,
    onFailure: (String) -> Unit
)

data class MonthYear(val month: Int, val year: Int)

expect fun getCurrentMonthYear(): MonthYear

expect fun openUrl(url: String)

expect suspend fun getRemoteConfigString(key: String, defaultValue: String): String

expect suspend fun resolveImageUrl(pathOrUrl: String): String

expect fun getTrackings(
    userId: String,
    onSuccess: (List<MonthlyTracking>) -> Unit,
    onFailure: (String) -> Unit
)

expect fun saveTracking(
    userId: String,
    tracking: MonthlyTracking,
    onSuccess: (String) -> Unit,
    onFailure: (String) -> Unit
)

expect fun getAllUsers(
    onSuccess: (List<User>) -> Unit,
    onFailure: (String) -> Unit
)

expect fun getUserResources(
    targetUserId: String,
    onSuccess: (List<ResourceDetails>) -> Unit,
    onFailure: (String) -> Unit
)

expect fun getUserTrackings(
    targetUserId: String,
    onSuccess: (List<MonthlyTracking>) -> Unit,
    onFailure: (String) -> Unit
)

expect fun listenToUserTrackings(
    targetUserId: String,
    onUpdate: (List<MonthlyTracking>) -> Unit,
    onFailure: (String) -> Unit
): () -> Unit